import React from "react";
import { Button, TextField, Grid } from "@mui/material";
import Abhaicons from "../../Images/Adharicon.svg";
import Abhashiled from "../../Images/material-symbols-light_shield-outline.svg";

const Step2OtpMobileVerification = ({
  otp,
  setOtp,
  mobile,
  setMobile,
  mobileOtp,
  setMobileOtp,
  showMobileOtpStep,
  onVerifyAadhaarOtp,
  onVerifyMobileOtp,
  onResendAadhaarOtp,
  onResendMobileOtp,
  // Aadhaar OTP Timer Props
  aadhaarCanResend = true,
  aadhaarFormattedTime = "01:00",
  aadhaarResendCount = 0,
  aadhaarMaxResendCount = 2,
  // Mobile OTP Timer Props
  mobileCanResend = true,
  mobileFormattedTime = "01:00",
  mobileResendCount = 0,
  mobileMaxResendCount = 2,
}) => {
  // Format OTP input
  const handleOtpChange = (e, setFunction) => {
    let value = e.target.value.replace(/\D/g, ""); // Only digits
    if (value.length > 6) value = value.slice(0, 6);
    setFunction(value);
  };

  // Format Mobile input
  const handleMobileChange = (e) => {
    let value = e.target.value.replace(/\D/g, ""); // Only digits
    if (value.length > 10) value = value.slice(0, 10);
    setMobile(value);
  };

  // Validations
  const isOtpValid = otp.length === 6;
  const isMobileValid = /^[6-9]\d{9}$/.test(mobile);
  const isMobileOtpValid = mobileOtp.length === 6;
  const isAadhaarVerifyEnabled = isOtpValid && isMobileValid;

  return (
    <div className="text-center">
      <img src={Abhaicons} alt="ABHA Icon" />
      <h5 className="sub-text">OTP Verification</h5>
      <p className="sub-para">
        Enter the 6-digit OTP sent to your registered Aadhaar mobile number
      </p>

      {!showMobileOtpStep ? (
        <>
          {/* Aadhaar OTP Input */}
          <div className="otp-container">
            <input
              type="text"
              value={otp}
              onChange={(e) => handleOtpChange(e, setOtp)}
              maxLength={6}
              className="otp-input"
              placeholder="_ _ _  -   _ _ _"
            />
          </div>

          {/* Mobile Number Input */}
          <Grid container spacing={2} className="mt-2">
            <Grid size={{ xs: 12, md: 12 }}>
              <TextField
                label="Mobile Number"
                variant="outlined"
                fullWidth
                size="small"
                value={mobile}
                onChange={handleMobileChange}
                placeholder="Enter 10-digit mobile number"
                inputProps={{
                  maxLength: 10,
                  inputMode: "numeric",
                }}
                error={mobile.length > 0 && !isMobileValid}
                helperText={
                  mobile.length > 0 && !isMobileValid
                    ? "Please enter a valid 10-digit mobile number"
                    : "It is preferable to use your Aadhaar-linked mobile number. If you choose to use a different mobile number, it will need to be validated again and will be used for all communication related to ABHA."
                }
              />
            </Grid>
          </Grid>

          {/* Verify Button */}
          <div className="d-flex justify-content-between mt-3">
            <Button
              variant="contained"
              fullWidth
              className={`verify-otp-btn ${isAadhaarVerifyEnabled ? "active" : ""}`}
              disabled={!isAadhaarVerifyEnabled}
              onClick={onVerifyAadhaarOtp}
            >
              Verify OTP
            </Button>
          </div>

          {/* Resend OTP */}
          <div className="d-flex justify-content-between align-items-center mt-3" style={{ fontSize: '0.9rem' }}>
            <span style={{ color: '#666' }}>Didn't receive OTP?</span>
            <div className="d-flex align-items-center gap-3">
              <button
                onClick={async () => {
                  try {
                    await onResendAadhaarOtp();
                  } catch (error) {
                    console.error('Failed to resend OTP:', error);
                  }
                }}
                disabled={!aadhaarCanResend}
                style={{
                  background: 'none',
                  border: 'none',
                  color: aadhaarCanResend ? '#155DFC' : '#999',
                  cursor: aadhaarCanResend ? 'pointer' : 'not-allowed',
                  textDecoration: aadhaarCanResend ? 'underline' : 'none',
                  fontWeight: 500,
                  padding: 0
                }}
              >
                Resend OTP ({aadhaarResendCount}/{aadhaarMaxResendCount})
              </button>
            </div>
            <span style={{ color: '#666', fontSize: '0.85rem' }}>
              {aadhaarFormattedTime} remaining
            </span>
          </div>
        </>
      ) : (
        <>
          {/* Mobile OTP Sub-Step */}
          <p className="sub-para mt-3">
            Your mobile number is different from Aadhaar registered number. Please verify your mobile number.
          </p>

          <div className="otp-container">
            <input
              type="text"
              value={mobileOtp}
              onChange={(e) => handleOtpChange(e, setMobileOtp)}
              maxLength={6}
              className="otp-input"
              placeholder="_ _ _  -   _ _ _"
            />
          </div>

          {/* Verify Mobile OTP Button */}
          <div className="d-flex justify-content-between mt-3">
            <Button
              variant="contained"
              fullWidth
              className={`verify-otp-btn ${isMobileOtpValid ? "active" : ""}`}
              disabled={!isMobileOtpValid}
              onClick={onVerifyMobileOtp}
            >
              Verify Mobile OTP
            </Button>
          </div>

          {/* Resend Mobile OTP */}
          <div className="d-flex justify-content-between align-items-center mt-3" style={{ fontSize: '0.9rem' }}>
            <span style={{ color: '#666' }}>Didn't receive OTP?</span>
            <div className="d-flex align-items-center gap-3">
              <button
                onClick={async () => {
                  try {
                    await onResendMobileOtp();
                  } catch (error) {
                    console.error('Failed to resend OTP:', error);
                  }
                }}
                disabled={!mobileCanResend}
                style={{
                  background: 'none',
                  border: 'none',
                  color: mobileCanResend ? '#155DFC' : '#999',
                  cursor: mobileCanResend ? 'pointer' : 'not-allowed',
                  textDecoration: mobileCanResend ? 'underline' : 'none',
                  fontWeight: 500,
                  padding: 0
                }}
              >
                Resend Mobile OTP ({mobileResendCount}/{mobileMaxResendCount})
              </button>
            </div>
            <span style={{ color: '#666', fontSize: '0.85rem' }}>
              {mobileFormattedTime} remaining
            </span>
          </div>
        </>
      )}

      <div className="para-ofadhar">
        <span>
          <img src={Abhashiled} alt="Shield" />
        </span>
        <p>
          Your Aadhaar details are secure and encrypted. OTP will be sent to
          your registered mobile number.
        </p>
      </div>
    </div>
  );
};

export default Step2OtpMobileVerification;